import { render, staticRenderFns } from "./AppSwitchSessionCurtain.vue?vue&type=template&id=4b357370&scoped=true&"
import script from "./AppSwitchSessionCurtain.vue?vue&type=script&lang=js&"
export * from "./AppSwitchSessionCurtain.vue?vue&type=script&lang=js&"
import style0 from "./AppSwitchSessionCurtain.vue?vue&type=style&index=0&id=4b357370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b357370",
  null
  
)

/* custom blocks */
import block0 from "./AppSwitchSessionCurtain.vue?vue&type=custom&index=0&blockType=i18n&lang=json5"
if (typeof block0 === 'function') block0(component)

export default component.exports